import * as React from "react";

import {
  LinkProps as RouterLinkProps,
  Link as RouterDomLink,
} from "react-router-dom";
import { Button } from "./ui/button";

export interface LinkOptions {
  isBold?: boolean;
  isGrayed?: boolean;
  isDisabled?: boolean;
}

interface LinkProps extends RouterLinkProps {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  children: React.ReactNode;
  options?: LinkOptions;
}

const getLinkStyles = (options: LinkOptions): string => {
  const styles: string[] = [];

  if (options.isBold) {
    styles.push("font-semibold");
  } else {
    styles.push("font-normal");
  }

  if (options.isGrayed) {
    styles.push("opacity-50 text-muted-foreground");
  }

  if (options.isDisabled) {
    styles.push("cursor-not-allowed pointer-events-none");
  }

  return styles.join(" ");
};

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, options = {}, ...props }, ref) => {
    const { icon: Icon, to, ...restProps } = props;

    const isDisabled = options.isDisabled ?? false;

    if (isDisabled) {
      return (
        <Button variant="link" className={className} disabled asChild>
          <span className={getLinkStyles(options)}>
            {Icon && <Icon className="shrink-0 h-5 w-5 mr-1" />}
            {props.children}
          </span>
        </Button>
      );
    }

    return (
      <Button variant="link" asChild className={className}>
        <RouterDomLink
          ref={ref}
          to={to}
          {...restProps}
          className={getLinkStyles(options)}
        >
          {Icon && <Icon className="shrink-0 h-5 w-5 mr-1" />}
          {props.children}
        </RouterDomLink>
      </Button>
    );
  },
);
Link.displayName = "Link";

export { Link };
